export default __webpack_public_path__ + "6d5845f30a3e7ff85880d74351d64632.gif";